<ngx-spinner bdColor="rgba(51,51,51,0.9)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: #fff;">Loading...</p>
</ngx-spinner>